import axios from 'axios';

// В продакшене — относительные пути (бэкенд сам отдаёт фронт и проксирует).
// В разработке — тот же хост, что открыт в браузере, на порту 5001.
// Благодаря этому можно зайти с телефона по http://<IP-мака>:3000 и API
// пойдёт на http://<IP-мака>:5001, а не на localhost самого телефона.
const API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : `http://${window.location.hostname}:5001/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // 401 на эндпоинтах входа/регистрации/сброса — это «неверные данные»,
    // а не протухшая сессия. Не редиректим (иначе страница перезагружается и
    // ошибка «Неверный пароль» не успевает показаться) — пробрасываем дальше,
    // её покажет тостом тот, кто вызвал.
    const url = error.config?.url || '';
    const isAuthEndpoint = /\/auth\/(login|register|forgot-password|reset-password)/.test(url);
    if (error.response?.status === 401 && !isAuthEndpoint) {
      // Протухшая сессия на защищённом запросе — выкидываем на вход.
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;